module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"pageTitle":"Ordini","pageMetaDescription":"Tutti ordini","NoOrdersFound":"Nessun ordine trovato"}}')
  delete Component.options._Ctor
}
